import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavLinksWithIcon, SubNavLinksWithIcon } from '../navigation';

@Component({
  selector: 'to-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavComponent {
  @Input() navBar: NavLinksWithIcon[];
  trackNav = (index: number, item: NavLinksWithIcon) => item.path;
  trackSubNav = (index: number, item: SubNavLinksWithIcon) => item.path;
}
